export type UnmatchedLineItemsNexSubmitMode =
    | 'dont_allow'
    | 'allow_manual'
    | 'allow_manual_and_automatic';

const MODES: ReadonlySet<string> = new Set([
    'dont_allow',
    'allow_manual',
    'allow_manual_and_automatic',
]);

/** Normalize stored boolean or enum to the current three-mode setting. */
export function normalizeUnmatchedLineItemsNexSubmitMode(
    raw: unknown,
): UnmatchedLineItemsNexSubmitMode {
    if (raw === true) return 'allow_manual';
    if (typeof raw === 'string' && MODES.has(raw)) {
        return raw as UnmatchedLineItemsNexSubmitMode;
    }
    return 'dont_allow';
}

/** Resolve mode from invoicing settings (supports legacy boolean field). */
export function resolveUnmatchedLineItemsNexSubmitMode(
    invoicingSettings?: {
        unmatchedLineItemsNexSubmitMode?: unknown;
        allowUnmatchedLineItemsOnNexSubmit?: unknown;
    } | null,
): UnmatchedLineItemsNexSubmitMode {
    return normalizeUnmatchedLineItemsNexSubmitMode(
        invoicingSettings?.unmatchedLineItemsNexSubmitMode ??
            invoicingSettings?.allowUnmatchedLineItemsOnNexSubmit,
    );
}

export function allowsManualUnmatchedNexSubmit(mode: UnmatchedLineItemsNexSubmitMode): boolean {
    return mode === 'allow_manual' || mode === 'allow_manual_and_automatic';
}
